module.exports = __webpack_public_path__ + "static/media/AlanImage10.987d3cf6.png";